import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { DataServiceBase } from './data-service-base.class';
import { IColumnDef } from './models/ui/column-defs/column-def.interface';
import { ILookupService } from './models/data-service/lookup-service.interface';
import { Identifyable } from './models/table-entities/identifyable.interface';
import { Observable, Subject, catchError, map, of, tap } from 'rxjs';

export abstract class LookupDataServiceBase<EntityType extends Identifyable>
  extends DataServiceBase<EntityType>
  implements ILookupService<EntityType>
{
  public abstract getDisplayName(data: EntityType): string;

  private loadedItems: EntityType[] = [];
  private dataLoadedSubject: Subject<void> = new Subject<void>();
  public dataLoaded$ = this.dataLoadedSubject.asObservable();
  constructor(configService: ConfigService, http: HttpClient) {
    super(configService, http);
    this.loadItems().subscribe();
    this.entryCreated$.subscribe(() => {
      this.loadItems().subscribe();
    });
    this.entryDeleted$.subscribe(() => {
      this.loadItems().subscribe();
    });
    this.entryUpdated$.subscribe(() => {
      this.loadItems().subscribe();
    });
  }

  loadItems(): Observable<boolean> {
    return this.getAll().pipe(
      tap((result) => {
        console.log(`[${this.constructor.name}]: Loading finished`, result);
        this.loadedItems = result;
        this.dataLoadedSubject.next();
      }),
      map(() => true), // explicitly return true for forkJoin
      catchError((err) => {
        console.error(`[${this.constructor.name}]: Error loading items`, err);
        this.loadedItems = [];
        this.dataLoadedSubject.error(err);
        return of(false);
      })
    );
  }

  getAllItems(): EntityType[] {
    return this.loadedItems;
  }
  getItemById(id: number): EntityType | undefined {
    return this.loadedItems.find((item) => item.id == id);
  }
  getValue(key: string | number): string | number {
    const item = this.getItemById(key as number);
    return item ? this.getDisplayName(item) : '';
  }
}
